module.exports = {"220102001":"南岭街道","220102002":"自强街道","220102003":"民康街道","220102004":"新春街道","220102005":"长通街道","220102006":"全安街道","220102007":"曙光街道","220102008":"永吉街道","220102009":"桃源街道","220102010":"鸿城街道","220102011":"明珠街道","220102012":"富裕街道","220102200":"幸福乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220102.json
// module id = 691
// module chunks = 0